/** Escape text for safe insertion into Scope HTML list items. */
export function escapeHtml(text: string): string {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

/** Convert Scope bullet lines to a TipTap-friendly HTML list. */
export function scopeLinesToHtml(lines: string[]): string {
    if (!lines.length) {
        return '<ul><li>Scope of work to be confirmed.</li></ul>';
    }
    const items = lines.map(line => `<li>${escapeHtml(line)}</li>`).join('');
    return `<ul>${items}</ul>`;
}

/** Default Wood section HTML from plywood / lumber totals (exact input totals). */
export function defaultWoodHtml(plywoodSheets: number, lumberPieces: number): string {
    return (
        `<p>- This contract include Plywood Sheets up to: <strong>${plywoodSheets}</strong> Plywood Sheets</p>` +
        `<p>- This contract includes trusses or fascias up to: <strong>${lumberPieces}</strong> Linear Feet</p>`
    );
}

/** Default Permits section HTML. */
export function defaultPermitsHtml(): string {
    return '<p>Permit fees by: Owner</p>';
}

